module.exports = __webpack_public_path__ + "static/media/icon-casino.f4d2ef10.svg";